import React from "react";

/**
 * Badge / pill component for status display.
 *
 * @param {{ children: React.ReactNode, variant?: 'default'|'success'|'warning'|'danger'|'info', className?: string }} props
 */

const VARIANT_CLASSES = {
  default: "bg-secondary/30 text-textSecondary",
  success: "bg-success/20 text-success",
  warning: "bg-yellow-500/20 text-yellow-400",
  danger: "bg-destructive/20 text-destructive",
  info: "bg-primary/20 text-primary",
};

export function Badge({ children, variant = "default", className = "" }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
        VARIANT_CLASSES[variant] || VARIANT_CLASSES.default
      } ${className}`}
    >
      {children}
    </span>
  );
}
